export default __webpack_public_path__ + "static/media/normalFetalHR.8ba11b44.gif";